import ApiClient from './ApiClient'

export default class UsersClient extends ApiClient {
    getAll = (page = 1, filter = '') => this.get('/users', { page, filter })

    deleteUser = userId => this.delete(`/users/${userId}`)
}
